import Comment from '../../resource_models/comment'

export const isLoading = (state) => {
  return state.isCallingAPI
}

export const all = (state) => {
  return state.result.map((id) => new Comment(state.entities[id]))
}

export const find = (state) => (id) => {
  return new Comment(state.entities[id])
}

export const meta = (state) => {
  return state.meta
}

export const errors = (state) => {
  return state.errors
}
